module.exports = __WEBPACK_EXTERNAL_MODULE_49__;


//////////////////
// WEBPACK FOOTER
// external "fenix-ui-filter"
// module id = 49
// module chunks = 0